module.exports = __webpack_public_path__ + "portal-static/img/zs.356b9f61.png";